import { useEffect, useState } from 'react';
import Container from '../components/containers/container';
import RecommendedContainer from '../components/containers/discover/recommended.container';
import TrendingContainer from '../components/containers/discover/trending.container';
import Header from '../components/header/default.header';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import HTab from '../components/navigation/tabs/htab';
import { DISCOVER_TAB_OPTIONS } from '../components/navigation/tabs/tab-options';
import Search from '../components/overlay/search';

export default function Explore() {
  const [currentValue, setCurrentValue] = useState(
    DISCOVER_TAB_OPTIONS.RECOMMENDED
  );

  const CONTENT_COMPONENT_MAP = {
    [DISCOVER_TAB_OPTIONS.RECOMMENDED]: () => <RecommendedContainer />,
    [DISCOVER_TAB_OPTIONS.TRENDING]: () => <TrendingContainer />,
  };

  useEffect(() => {
    document.title = 'The Base | Discover';
  }, []);
  return (
    <MainLayout>
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main className="relative py-2">
          <Container extensions="mobile:px-2 tablet-lg:px-[40px] border-b border-dark-gray py-4 bg-black z-30">
            <Search />
          </Container>
          <Container extensions="relative">
            <HTab
              current={currentValue}
              set={setCurrentValue}
              tabOptions={DISCOVER_TAB_OPTIONS}
              tabContent={CONTENT_COMPONENT_MAP}
              tabControlClassName="mobile:px-2 tablet-lg:px-[40px] py-4 bg-black border-b border-l border-dark-gray sticky top-0"
              withoutCloseEffect
            />
          </Container>
        </MainLayout.Main>
      </MainLayout.Content>
      <MainLayout.Aside>
        <></>
      </MainLayout.Aside>
    </MainLayout>
  );
}
